import { ModalsManager } from '@/components/modals/modalsManager';

import { FeedShortcutsDialog } from './FeedShortcutsDialog';

export const showFeedShortcuts = () =>
  ModalsManager.show(FeedShortcutsDialog, {}, { unique: true });
